export default class Point{
    constructor(x,y){    
        this.x=x;
        this.y=y;
    }    

    isValid = () =>{
        return (0 <= this.x && this.x <= 6 && 0 <= this.y && this.y <= 6);
    }
    above = () =>{
        if(this.y===0) return new Point(-1, -1);
        return new Point(this.x, this.y-1);      
    };

    right = () => {
        if(this.x===6) return new Point(-1, -1);
        return new Point(this.x+1, this.y);      
    };

    below = () => {
        if(this.y===6) return new Point(-1, -1);
        return new Point(this.x, this.y + 1);
    };

    left = () => {
        if(this.x==0) return new Point(-1, -1);
        return new Point(this.x-1, this.y);
    };

    convertToIndex = () => {
        return this.x * 7 + this.y;
    }

    static createFromIndex = (index) => {
        let X = Math.floor(index / 7);
        let Y = index % 7;
        return new Point(X, Y);
    }
}